import React from 'react';
import { List } from 'immutable';
import PropTypes from 'prop-types';

import { ButtonWithIcon } from '@els/els-react--button';

function TreeViewDialogFooter(props) {
  const { tags, onClickLimitTo, onClickExclude, onClickClearAllSelected } = props;

  if (!tags) {
    return null;
  }

  const disableControls = tags.count() === 0;

  return (
    <>
      <ButtonWithIcon
        data-e2e="clear-selected"
        type="borderless"
        size="small"
        sprite="Close"
        linkIconSize="s"
        iconRight
        disabled={disableControls}
        onClick={onClickClearAllSelected}
        className="tree-view-dialog-footer-close-all e2e-clear-selected">
        Clear selected
      </ButtonWithIcon>

      <div className="els-btn-group-right">
        <ButtonWithIcon
          data-e2e="tree-view-limit"
          type="primary"
          size="small"
          sprite="ChevronRight"
          linkIconSize="s"
          iconRight
          disabled={disableControls}
          onClick={onClickLimitTo}
          className="e2e-tree-view-limit">
          Limit to
        </ButtonWithIcon>
        <ButtonWithIcon
          data-e2e="tree-view-exclude"
          type="primary"
          size="small"
          sprite="ChevronRight"
          linkIconSize="s"
          iconRight
          disabled={disableControls}
          onClick={onClickExclude}
          className="e2e-tree-view-exclude">
          Exclude
        </ButtonWithIcon>
      </div>
    </>
  );
}

TreeViewDialogFooter.propTypes = {
  tags: PropTypes.instanceOf(List).isRequired,
  onClickLimitTo: PropTypes.func.isRequired,
  onClickExclude: PropTypes.func.isRequired,
  onClickClearAllSelected: PropTypes.func.isRequired,
};

export default TreeViewDialogFooter;
